import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import Logo from "../components/Logo";
import ResetButton from "../components/ResetButton";
import Row from "../components/Row";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import {
  navigateToNext,
  NavigateToNext,
  setUserValue,
  SetUserValue
} from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

interface IOptInDispatchProps {
  onNavigateToNext: NavigateToNext;
  onSetUserValue: SetUserValue;
}

type OptInOwnProps = RouteComponentProps;

interface IOptInStateProps {
  languageStrings: IStrings;
  theme: Theme.Props;
  user: Users.User;
}

type OptInProps = IOptInDispatchProps & OptInOwnProps & IOptInStateProps;

const OptInContainer = styled(Container)`
  grid-template-rows: 20vh 55vh 25vh;
`;

const DisclaimerText = styled("div")`
  color: ${(props: { color: string }) => props.color};
  text-shadow: 1px 1px 1px black;
  font-size: 14px;
  width: 400px;
`;

class OptIn extends React.Component<OptInProps> {
  public handleEnter = optIn => {
    const { onNavigateToNext, onSetUserValue } = this.props;

    onSetUserValue({ name: "optin", value: optIn });

    onNavigateToNext();
  };

  public render() {
    const {
      languageStrings: strings,
      theme: { colors, logo }
    } = this.props;

    return (
      <ErrorBoundary>
        <OptInContainer>
          <Row align="center" justify="center">
            <Logo logo={logo} />
          </Row>
          <Column align="center" justify="space-around">
            <Title color={colors.secondary} size="3rem">
              {strings.optInHeader}
            </Title>
            <Row align="center" justify="center">
              <Button
                bg={colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter(true)}
              >
                {strings.yes}
              </Button>
              <Button
                bg={colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter(false)}
              >
                No
              </Button>
            </Row>
          </Column>
          <Row align="center" justify="center">
            <DisclaimerText color={colors.warning}>
              {strings.disclaimer}
            </DisclaimerText>
          </Row>
          <Row align="center" justify="center">
            <ResetButton />
          </Row>
        </OptInContainer>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({
  router: { languageStrings },
  theme,
  user
}: IState) => ({
  languageStrings,
  theme,
  user
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
  onSetUserValue: setUserValue
};

export default connect<IOptInStateProps, IOptInDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(OptIn);



// WEBPACK FOOTER //
// ./src/views/OptIn.tsx